import React, { useState, useEffect } from "react";
import SimpleBar from "simplebar-react";
import { useLocation } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBook,
  faHome,
  faSignOutAlt,
  faTimes,
  faUser,
  faList,
  faInbox,
  faQuestionCircle,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import { Nav, Badge, Image, Button, Accordion, Navbar } from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";

import { Routes } from "../routes";
import ThemesbergLogo from "../assets/img/themesberg.svg";
import ReactHero from "../assets/img/logo1.png";
import ProfilePicture from "../assets/img/team/profile-picture-3.jpg";
import axios from "axios";
import "./Sidebar.css";
import BASE_URL from "../config";


export default (props = {}) => {
  const location = useLocation();
  const { pathname } = location;
  const [show, setShow] = useState(false);
  const [userType, setUserType] = useState(null); // State for user type
  const showClass = show ? "show" : "";

  const onCollapse = () => setShow(!show);

  // Simulate fetching user type (replace with your actual API or context logic)
  useEffect(() => {
    const fetchUserType = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api.php?type=fetchUserType`, { withCredentials: true });
        if (response.data.status === "success") {
          setUserType(response.data.user_type);
        } else {
          console.error("Failed to fetch user type:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching user type:", error);
      }
    };

    fetchUserType();
  }, []);

  const NavItem = (props) => {
    const { title, link, external, target, icon, image, badgeText, badgeBg = "secondary", badgeColor = "primary" } = props;
    const classNames = badgeText ? "d-flex justify-content-start align-items-center justify-content-between" : "";
    const navItemClassName = link === pathname ? "active" : "";
    const linkProps = external ? { href: link } : { as: Link, to: link };

    return (
      <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
        <Nav.Link {...linkProps} target={target} className={classNames}>
          <span>
            {icon ? <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span> : null}
            {image ? <Image src={image} width={20} height={20} className="sidebar-icon svg-icon" /> : null}

            <span className="sidebar-text">{title}</span>
          </span>
          {badgeText ? (
            <Badge pill bg={badgeBg} text={badgeColor} className="badge-md notification-count ms-2">{badgeText}</Badge>
          ) : null}
        </Nav.Link>
      </Nav.Item>
    );
  };

  return (
    <>
      <Navbar expand={false} collapseOnSelect variant="dark" className="navbar-theme-primary custom-navbar px-4 d-md-none">
        <Navbar.Brand className="me-lg-5" as={Link} to={Routes.DashboardOverview.path}>
          <Image src={ReactHero} className="navbar-brand-light" />
        </Navbar.Brand>
        <Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse}>
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>
      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar className={`collapse ${showClass} sidebar custom-sidebar d-md-block text-white`}>
          <div className="sidebar-inner px-4 pt-2">
            <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
              <div className="d-flex align-items-center">
                <div className="user-avatar lg-avatar me-4">
                  <Image src={ProfilePicture} className="card-img-top rounded-circle border-white" />
                </div>
                <div className="d-block">
                  <h6>Hi, Jane</h6>
                  <Button as={Link} variant="secondary" size="xs" to={Routes.Signin.path} className="text-dark">
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Sign Out
                  </Button>
                </div>
              </div>
              <Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>
            <Nav className="flex-column  pt-md-0">
              {/* <Image src={ReactHero} as={Link} to={Routes.Signin.path} className="navbar-brand-light mb-2" /> */}
              <div className="sidebar-logo-wrapper">
                <Image
                  src={ReactHero}
                  as={Link}
                  to={Routes.Signin.path}
                  className="sidebar-logo"
                />
              </div>
              {/* Render navigation items conditionally based on userType */}
              {userType == 2 ? (
                <>
                  <NavItem title="Dashboard" link={Routes.DashboardOverview.path} icon={faHome} />
                  <NavItem title="Application" link={Routes.Applications.path} icon={faList} />
                  <NavItem title="FAQ's" link={Routes.FAQ.path} icon={faQuestionCircle} />
                  <NavItem title="User Manual" link={Routes.UserManual.path} icon={faBook} />
                </>
              ) : (
                <>
                  <NavItem title="Dashboard" link={Routes.DashboardOverview.path} icon={faHome} />
                  <NavItem title="User" link={Routes.Userlists.path} icon={faUser} />
                  <NavItem title="Application" link={Routes.Applications.path} icon={faList} />
                  <NavItem title="Auto Reply" link={Routes.AutoReply.path} icon={faPaperPlane} />
                  <NavItem title="FAQ's" link={Routes.FAQ.path} icon={faQuestionCircle} />
                  <NavItem title="User Manual" link={Routes.UserManual.path} icon={faBook} />
                </>
              )}
            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};
